import { render, staticRenderFns } from "./EmailTemplate.vue?vue&type=template&id=15f15977&scoped=true"
import script from "./EmailTemplate.vue?vue&type=script&lang=js"
export * from "./EmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./EmailTemplate.vue?vue&type=style&index=0&id=15f15977&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f15977",
  null
  
)

export default component.exports